import React, { useState } from 'react';
import { UserService } from '../Service';
import { useAppContext } from '../../../../contexts/AppContext';
import { useAuthContext } from '../../../../contexts/AuthContext';
import FileUploadUser from '../../../../components/files/FileUploadUser';
import AvatarUser from '../../../../components/AvatarUser';
import { SettingsRow, SettingsSection } from '../../estabelecimento/Form/SettingsGroup';

const service = new UserService();

export default function ConfiguracoesContaGeral() {
    const [loading, setLoading] = useState(false);
    const [uploading, setUploading] = useState(false);
    const { user, changeUser } = useAuthContext();
    const { successSnackbar, errorSnackbar } = useAppContext();

    const [photoURL, setPhotoURL] = useState(user?.photoURL || '');
    const [displayName, setDisplayName] = useState(user?.displayName || '');

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const update = { displayName, photoURL };

        try {
            setLoading(true);
            await service.updateProfile(update);

            changeUser(update);
            successSnackbar('Perfil editado com sucesso!');
        } catch (e) {
            errorSnackbar('Ocorreu um erro ao editar o perfil.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="grid gap-6 xl:grid-cols-2 xl:items-start">
                <SettingsSection
                    title="Foto de perfil"
                    footer="Use uma imagem quadrada para melhor enquadramento (JPG ou PNG)."
                >
                    <FileUploadUser value={photoURL} setValue={setPhotoURL} onLoadingChange={setUploading}>
                        {({ loading: loadingFile, fileData, error, handleChange, removeFile, inputRef }) => {
                            const previewUrl = fileData?.url;
                            const isBusy = loading || loadingFile;

                            return (
                                <div className="flex items-center gap-4 p-4">
                                    <div className="relative shrink-0">
                                        <AvatarUser name={displayName} photoURL={previewUrl} size="h-20 w-20 !text-2xl" />
                                        {loadingFile && (
                                            <div className="absolute inset-0 flex items-center justify-center rounded-full bg-black/40">
                                                <span className="loading loading-spinner loading-sm text-white"></span>
                                            </div>
                                        )}
                                    </div>

                                    <div className="flex min-w-0 flex-col items-start gap-1">
                                        <input
                                            disabled={isBusy}
                                            type="file"
                                            id="profilePicture"
                                            ref={inputRef}
                                            accept="image/*"
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                            className="hidden"
                                        />
                                        <button
                                            type="button"
                                            className="estab-link-button"
                                            disabled={isBusy}
                                            onClick={() => inputRef.current?.click()}
                                        >
                                            {previewUrl ? 'Alterar foto' : 'Escolher foto'}
                                        </button>
                                        {previewUrl && (
                                            <button
                                                disabled={isBusy}
                                                type="button"
                                                onClick={() => {
                                                    removeFile();
                                                }}
                                                className="estab-link-button estab-link-button--destructive"
                                            >
                                                Remover
                                            </button>
                                        )}
                                        {error && <div className="text-xs text-error">{error}</div>}
                                    </div>
                                </div>
                            );
                        }}
                    </FileUploadUser>
                </SettingsSection>

                <SettingsSection title="Identidade">
                    <SettingsRow label="Nome" htmlFor="name">
                        <input
                            disabled={loading}
                            type="text"
                            id="name"
                            required
                            value={displayName}
                            onChange={(e) => setDisplayName(e.target.value)}
                            className="input estab-field"
                            placeholder="Seu nome"
                            autoComplete="name"
                        />
                    </SettingsRow>
                </SettingsSection>
            </div>

            <div className="estab-savebar mt-6">
                <button
                    className="btn btn-primary w-full sm:w-auto sm:min-w-[11rem]"
                    type="submit"
                    disabled={loading || uploading}
                >
                    {loading && <span className="loading loading-spinner loading-sm"></span>}
                    Salvar alterações
                </button>
            </div>
        </form>
    );
}
